import { css } from '@emotion/react';

export const button = css`
  border: none;
  outline: none;
  appearance: none;
  background-color: var(--color-primary);
  color: white;
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
`;

export const capitalize = css`
  text-transform: capitalize;
`;

export const wrapper = css`
  // to couterfeit modal default padding 2rem
  margin: -2rem;
  min-height: calc(100vh - (3rem * 2));
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 2rem;
`;

// customer container styles go below
export const eligibleCampaignsContainer = css`
  // background: hotpink;
  // background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 1.5rem;
  flex: 1;
`;

export const title = css`
  margin: 1.5rem auto 0;
`;

export const campaignWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
  width: 100%;
  max-width: 28rem;
  border-radius: 8px;
  box-shadow: -1px 2px 6px rgba(0, 0, 0, 0.21);
  padding: 0.75rem 0.8rem;
  margin-bottom: 0.75rem;
  cursor: pointer;
`;

export const noCampaignsFound = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0;
  width: 100%;
  max-width: 25rem;
`;

export const nameWrapper = css`
  padding-right: 1rem;
`;
export const name = css`
  font-weight: 600;
`;
export const expiry = css`
  font-size: 0.875rem;
  color: var(--text-grey);
`;

export const redeemBtn = css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 10rem;
  min-height: 2.5rem;
  font-size: 0.875rem;
  ${button}
`;

export const customerDetails = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.5rem 0;
`;

export const entryWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 1.5rem;
`;

export const entryLabel = css`
  color: var(--text-grey);
`;

export const entryContent = css`
  font-weight: bold;
`;

export const successText = css`
  font-size: 1.5rem;
  font-weight: bold;
`;

export const CTA = css`
  border: 1px solid var(--color-primary);
  appearance: none;
  background-color: transparent;
  color: var(--color-primary);
  font-weight: 500;
  margin: 2rem 0;
  padding: 0.75rem 2rem;
  border-radius: 5px;
  line-height: 1.2;
  height: 2.75rem;
  width: 16rem;
  cursor: pointer;

  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
`;

export const campaignNameAlias = css`
  color: #919191;
`;
